export const ListQueryKey = 'rollRecords';
export const DetailQueryKey = 'rollRecord';

export const Urls = {
  selectUrl: '/rollRecord/list',
  updateUrl: '/rollRecord/update',
  deleteUrl: '/rollRecord/delete',
  createUrl: '/rollRecord/create',
  detailUrl: '/rollRecord/info',
};
